<template>
    <div>
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>售后订单列表</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="swb-back-row">
            <div class="order-title mb10">
                <div class="order-title-content fl">
                    <ul class="order-status" v-if="flag">
                        <li class="">零售商名称：{{contranct.fstPartyName}}</li>
                        <li class="">合同编号：{{contranct.fstPartyHtBh}}</li>
                        <li v-if="contranct.confirmed">合同状态：合同履约中</li>
                        <li v-if="contranct.fullfilled" class="">合同状态：履约完成</li>
                        <li v-if="contranct.checked" class="">合同状态：已验收</li>
                    </ul>
                </div>
            </div>
            <swb-servc-order-search :no="no" :after="false" @showAfterServcOrderSearch="afterServcOrderSearch"></swb-servc-order-search>
            <div class="orders-list-container">
                <table class="orders-list-panel1">
                    <colgroup>
                        <col width="350px">
                        <col width="250px">
                        <col width="150px">
                        <col width="150px">
                        <col width="100px">
                        <col width="100px">
                    </colgroup>
                    <thead class="orders-header">
                    <tr class="">
                        <th>服务信息</th>
                        <th style="text-align: left">服务商信息</th>
                        <th>金额</th>
                        <th>交易状态</th>
                        <th>交付状态</th>
                        <th>操作</th>
                    </tr>
                    </thead>
                    <tbody class="orders-body" v-if="servOrderList != null && servOrderList.length > 0" v-for="(servcOrder, index) in servOrderList">
                    <tr class="blank-row">
                        <td colspan="6"></td>
                    </tr>
                    <tr class="abstract-row">
                        <td colspan="6">
                            <div class="abstract-content">
                                <span class="mr5 font-black">订单号:{{servcOrder.no}}</span>
                                <span class="mr5 font-black">{{servcOrder.createTime}}</span>
                                <span class="swb-btn-link mt5" @click.stop="toTradeVoucherList(servcOrder.tradeNo)">交易单号:{{servcOrder.tradeNo}}</span>
                                <span class="mr5 font-black"></span>
                                <span class="mr5 font-black"></span>
                                <span class="mr5 font-black"></span>
                            </div>
                            <div v-if="servcOrder.proxied" class="table-tips order"></div>
                        </td>
                    </tr>
                    <tr class="info-row">
                        <td>
                            <div class="goods-info-block" style="overflow: hidden" v-if="servcOrder.itemList != null && servcOrder.itemList.length > 0" v-for="(servcOrderItem, index) in servcOrder.itemList">
                                <div class="goods-item clearfix">
                                    <div class="good-img">
                                        <img v-if="servcOrderItem.servcFileBrowseUrl != null" class="wh100" :src="servcOrderItem.servcFileBrowseUrl"/>
                                    </div>
                                    <div class="good-msg">
                                        <p class="ellipsis-2 font12 align-left">
                                            <span>{{servcOrderItem.title}}</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td>
                            <div>
                                <div class="font14 align-left">{{servcOrder.servicerName}}</div>
                                <div class="font14 align-left">预约上门时间:{{servcOrder.planTime}}</div>
                            </div>
                        </td>
                        <td>
                            <div class="font-gray1">
                                <span>总额 ¥<b class="pri">{{parseFloat(servcOrder.amount).toFixed(2)}}</b></span>
                            </div>
                        </td>
                        <td>
                            <div v-if="servcOrder.servicerShopFlag == true">{{servcOrder.servicerShopName}}</div>
                            <div class="font14 font-gray2" v-if="servcOrder.workAssignStateX != null">
                                <span>派工状态:{{workAssignStateX[servcOrder.workAssignStateX]}}</span>
                            </div>
                        </td>
                        <td>
                            <div class="font14 font-gray2" v-if="servcOrder.state != null">{{servcOrder.state}}</div>
                            <div class="swb-btn-link" v-if="checkActionPerm('view_detail')" @click="searchOrder(servcOrder.id)">
                                <i class="icon iconfont"></i><span>订单详情</span>
                            </div>
                        </td>
                        <td>
                            <div class="swb-btn-link" v-if="checkActionPerm('cancel') && servcOrder.cancellable &&　!servcOrder.cancelled" @click="doCancalServcOrder(servcOrder.id)">
                                <span>取消</span>
                            </div>
                            <div class="swb-btn swb-btn-link" v-if="checkActionPerm('initiate_complaint')" @click="complaintSave(servcOrder.id)">
                                <span>发起投诉</span>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="block pagination-layout">
                <el-pagination background class="mt10" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="total, sizes, prev, pager, next, jumper"></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { checkUserActionPerm } from '../index'
    import { getDefaultPageSizes } from '../../../src/app.conf'

    import contractApi from '../../api/contract'
    import userApi from '../../api/user'
    import servcOrderApi from '../../api/servcOrder'

    import SwbServcOrderOperate from './ServcOrderOperate';
    Routes.add(SwbServcOrderOperate);

    import SwbComplaintSave from '../custsvc/ComplaintSave';
    Routes.add(SwbComplaintSave);

    import SwbTradeVoucherList from '../tradeVoucher/TradeVoucherList';
    Routes.add(SwbTradeVoucherList);

    import SwbServcOrderSearch from './ServcOrderSearch'
    Vue.regist(SwbServcOrderSearch);

    export default {
        name: 'swb-after-sale-order-list',
        path: '/servc/order/list/after/sale',
        pathOld: '/servc/order/after/sale/list',
        avlActions: 'view_detail|initiate_complaint|cancel',
        avlScopes: 'retailer',
        desc: '服务售后订单列表',
        authen: false,
        data: function () {
            return {
                servOrderList: [],
                contractId: null,
                servcOrderStateList: [],
                workAssignStateX: [],
                servcOrderState: null,
                no: null,
                afterSaleSrcOrderNo: null,
                contranct: {},
                isSelf: true,
                contractFlag: false,
                userIsShopFlag: false,
                flag: false,
                value6: '',
                //
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                pageNumber: 1,
                flag: false,
                //排序、搜索
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                }
            }
        },
        created: function () {
            let self = this;
            self.afterSaleSrcOrderNo = this.$route.query.no || null;
            //----------------------分页--------------------------------
            //保持pageSize的一致性
            this.pageSize = this.pageSizes.first();
            //----------------------查询------------------------------s

            self.servcOrderStateList = getEnumList("servcOrderState");
            self.workAssignStateX = getEnumMap("workAssignStateX", "value2text");

            if(self.contractId != null) {
                self.getContractById(this.contractId);
                self.flag = true;
            }
            self.getCurrentUserInfo();

        },
        methods: {
            afterServcOrderSearch: function (data) {
                this.queryModel = data;
                this.getServOrderList();
            },
            // 检查资源具体操作权限（可选的是否为指定的岗位id）
            checkActionPerm: function (action, targetPostId) {
                return checkUserActionPerm(Vue.$getClassInfo(this).path, action, targetPostId);
            },
            getContractById: function (contractId) {
                let self = this;
                let postData = {};
                postData.id = contractId;
                //
                let lastMsgBoxDlg = MsgBox.loading();
                contractApi.getContractInfo(postData, function (result) {
                    lastMsgBoxDlg.close();
                    if(result.type == "info") {
                        self.contranct = result.data;
                    }
                });
            },
            getCurrentUserInfo: function () {
                let self = this;
                userApi.getUserInfoByContext({}, function (result) {
                    if(result.type == "info") {
                        self.userIsShopFlag = result.data.scopeEntity.shopFlag;
                        let servcOrderStateList = getEnumList("servcOrderState", true);
                        if(self.userIsShopFlag) {
                            for(let i = 0; i < servcOrderStateList.length; i++) {
                                let servcOrderState = servcOrderStateList[i];
                                if(servcOrderState.value == 2) {
                                    servcOrderStateList.splice(i, 1);
                                }
                            }
                        }
                        self.servcOrderStateList = servcOrderStateList;
                        self.getServOrderList();
                    }
                })
            },
            selectionMenu: function (value) {
                let self = this;
                let servcOrderStateList = self.servcOrderStateList;
                for(let i = 0; i < servcOrderStateList.length; i++) {
                    let servcOrderState = servcOrderStateList[i];
                    if(servcOrderState.value == value) {
                        self.servcOrderState = value;
                        self.getServOrderList();
                    }
                }
            },
            handleSizeChange: function (val) {
                this.pageSize = val;
                this.handlePageChange(1);
            },
            handlePageChange: function (val) {
                let self = this;
                this.pageNumber = val;
                this.getServOrderList();
            },
            getServOrderList: function () {
                let self = this;
                let postData = {};

                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems.isSelf = self.isSelf;
                if(!Utils.isNoB(self.no)) {
                    filterItems.no = self.no;
                }
                if(self.servcOrderState == 2) {
                    filterItems.servicerShopFlag = false;
                }
                if(Utils.isNoB(self.afterSaleSrcOrderNo)) {
                    filterItems.afterSaleSrcOrderNo = self.afterSaleSrcOrderNo;
                }
                filterItems.afterSaleFlag = true;
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let lastMsgBoxDlg = MsgBox.loading();
                servcOrderApi.getServOrderList(postData, function (result) {
                    lastMsgBoxDlg.close();
                    if(result.type == "info") {
                        let data = result.data;
                        let servOrderList = data.rows;
                        //
                        self.servOrderList = servOrderList;
                        /*for(let i = 0,count =servOrderList.length;i<count;i++ ){
                         let servOrder = servOrderList[i];
                         let workAssignStateX = {};
                         if(servOrder.workAssignStateX != null){
                         workAssignStateX = self.workAssignStateXList[servOrder.workAssignStateX];
                         }else{
                         workAssignStateX = self.workAssignStateXList[0]
                         }
                         servOrder.workAssignStateX = workAssignStateX.text;
                         }*/
                        self.totalCount = data.pagination.totalCount;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            selectionMenu: function (value) {
                let self = this;
                let servcOrderStateList = self.servcOrderStateList;
                for(let i = 0; i < servcOrderStateList.length; i++) {
                    let servcOrderState = servcOrderStateList[i];
                    if(servcOrderState.value == value) {
                        self.servcOrderState = value;
                        self.getServOrderList();
                    }
                }
            },
            searchOrder: function (orderId) {
                this.$router.push({
                    path: SwbServcOrderOperate.path,
                    query: {
                        id: orderId,
                    }
                });

            },
            // 发起投诉
            complaintSave: function (orderId) {
                let subjectType = getEnumInfoWith("complaintSubjectType", "name", "ServcOrder");
                //
                this.$router.push({
                    path: SwbComplaintSave.path,
                    query: {
                        orderId: orderId,
                        subjectType: subjectType.value,
                    }
                })
            },
            toTradeVoucherList: function (tradeNo, tradeType) {
                let self = this;
                self.$router.push({
                    path: SwbTradeVoucherList.path,
                    query: {
                        no: tradeNo,
                        tradeVoucherType: 1
                    }
                })
            },
            parseFloat: function (price) {
                if(isNoB(price)) {
                    price = 0.00;
                }
                return Utils.parseFloat(price);
            },
            doCancalServcOrder: function (orderId) {
                let self = this;
                self.$prompt('请输入取消原因', '取消确认对话框', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(function (data) {
                    let cancelCause = data.value;
                    //
                    let postData = {};
                    postData.orderId = orderId;
                    postData.cancelCause = cancelCause;
                    //
                    let msgBoxDlg = MsgBox.loading();
                    servcOrderApi.doCancelServcOrder(postData, function (result) {
                        if(result.type == "info") {
                            MsgBox.info("操作成功");
                            setTimeout(function () {
                                self.getServOrderList();
                                msgBoxDlg.close();
                            }, 3000);
                        } else {
                            msgBoxDlg.close();
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {

                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/servcOrder/AfterSaleOrderList.vue